import $ from "jquery";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "jquery-validation/dist/jquery.validate.min.js";
import "jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.min.js";

window.jQuery = window.$ = $;
window.br = window.br || {};

require("./store/state");

require("./account/account-details.js");

// Require makes these execute in place 
// instead of being modules like with import
require("./image_gallery.js");
require("./header.js");
require("./light-or-dark-mode.js");
require("./categoryview.js");
//require("./product.js");
require("./store/nav-cart");



console.log("Main app loaded " + new Date());

$(document).ready(function () {

    $(".preload").each(function (index, element) {
        setTimeout(function () { $(element).removeClass("preload") }, 10);
    });

});